import React, { useEffect, useState } from "react";
import { LIVE_NOTIFS } from "@/data/landing";
import { LANDING } from "@/constants/testIds";
import { X, ShoppingBag } from "lucide-react";

export default function LiveNotifications() {
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(false);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    if (closed) return;
    const show = setTimeout(() => setVisible(true), 8000);
    return () => clearTimeout(show);
  }, [closed]);

  useEffect(() => {
    if (closed || !visible) return;
    const hideAfter = setTimeout(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx((p) => (p + 1) % LIVE_NOTIFS.length);
        setVisible(true);
      }, 6000);
    }, 5000);
    return () => clearTimeout(hideAfter);
  }, [visible, idx, closed]);

  if (closed || !visible) return null;
  const n = LIVE_NOTIFS[idx];

  return (
    <div
      data-testid={LANDING.liveNotif}
      className="fixed bottom-4 left-4 z-40 bg-white rounded-2xl shadow-xl px-4 py-3 max-w-xs slide-l hidden sm:block border border-black/5"
    >
      <button
        onClick={() => setClosed(true)}
        className="absolute top-1 right-1 text-[#bbb] hover:text-[#0e0e10] p-1"
        aria-label="Dismiss"
      >
        <X size={13} />
      </button>
      <div className="flex items-start gap-3">
        <span className="w-9 h-9 rounded-full bg-[#d8f06b] flex items-center justify-center flex-shrink-0">
          <ShoppingBag size={15} />
        </span>
        <div className="text-[13px] pr-3">
          <div className="font-bold text-[#0e0e10]">
            {n.name} from {n.city}
          </div>
          <div className="text-[#6b6b72] text-[11px]">
            just bought {n.qty}{" "}
            <span className="font-semibold text-[#0e0e10]">{n.color || "Classic White"}</span>{" "}
            pillow{n.qty > 1 ? "s" : ""} · {n.mins} min ago
          </div>
        </div>
      </div>
    </div>
  );
}
